import { ReactNode } from 'react';

import styles from './post.module.scss';

export type PostProps = {
  children?: ReactNode | ReactNode[];
};

export function Post({ children }: PostProps) {
  return <div className={styles['post']}>{children}</div>;
}
